import * as React from 'react';
import styled from 'styled-components';
import { BtnSearch } from './btn/BtnSearch';
import icon_close from './icon_close.svg';
import icon_search from './icon_search.svg';
import { usePopDocSel } from './PopDocSel';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  lang: string;
  sel: DocInfo;
  onChangeSel: (sel: DocInfo) => void;
}

export type DocInfo = { id: number; docTitle: string };

export const DocInput = ({ label, sel, onChangeSel, ...props }: Props) => {
  const [popDocSel, PopDocSel] = usePopDocSel();
  return (
    <Body {...props}>
      <Label>{label}</Label>
      <InputWrap>
        <InputDiv>
          <Icon src={icon_search} />
          {sel?.id && <IconClose src={icon_close} onClick={() => onChangeSel(null)} />}
          <Input
            value={sel?.docTitle || ''}
            readOnly
            data-tooltip-id='tooltip-docinput'
            data-tooltip-content={sel?.docTitle}
          />
        </InputDiv>
        <BtnSearch onClick={() => popDocSel.current.show({ lang: props.lang }).then((res) => onChangeSel(res))} />
      </InputWrap>
      <PopDocSel />
    </Body>
  );
};

const InputWrap = styled.div`
  display: flex;
  gap: 0.8rem;
`;

const InputDiv = styled.div`
  position: relative;
  flex-grow: 1;
`;
const Icon = styled.img`
  position: absolute;
  top: 50%;
  left: 0.6rem;
  transform: translateY(-50%);
`;

const IconClose = styled.img`
  position: absolute;
  top: 50%;
  right: 0.6rem;
  transform: translateY(-50%);
`;

const Input = styled.input`
  width: 100%;
  height: 3.8rem;
  border: 1px solid #c7d6ea;
  border-radius: 0.4rem;
  padding: 0 3.8rem;
`;

const Label = styled.label`
  font-size: 1.3rem;
  font-weight: 500;
  color: #7783a1;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;
